// import { Component } from '@theme/component';
// import { sectionRenderer } from '@theme/section-renderer';
// import { requestIdleCallback, viewTransition } from '@theme/utilities';
// import { ThemeEvents } from '@theme/events';
// import { PaginatedListAspectRatioHelper } from '@theme/paginated-list-aspect-ratio';

// /**
//  * A custom element that renders a paginated list of items.
//  *
//  * @typedef {object} Refs
//  * @property {HTMLUListElement} [grid] - The grid element.
//  * @property {HTMLSpanElement} [viewMorePrevious] - The view more previous button.
//  * @property {HTMLSpanElement} [viewMoreNext] - The view more next button.
//  * @property {HTMLElement[]} [cards] - The cards elements.
//  *
//  * @extends Component<Refs>
//  */
// export default class PaginatedList extends Component {
//   /**
//    * @type {Map<number, string>}
//    */
//   pages = new Map();

//   /** @type {IntersectionObserver | undefined} */
//   infinityScrollObserver;

//   /** @type {((value: void) => void) | null} */
//   #resolveNextPagePromise = null;

//   /** @type {((value: void) => void) | null} */
//   #resolvePreviousPagePromise = null;

//   /** @type {PaginatedListAspectRatioHelper} */
//   #aspectRatioHelper;

//   connectedCallback() {
//     super.connectedCallback();

//     /** @type {HTMLElement | null} */
//     const templateCard = this.querySelector('[ref="cardGallery"]');
//     if (templateCard) {
//       this.#aspectRatioHelper = new PaginatedListAspectRatioHelper({
//         templateCard,
//       });
//     }

//     this.#fetchPage('next');
//     this.#fetchPage('previous');
//     this.#observeViewMore();

//     // Listen for filter updates to clear cached pages
//     document.addEventListener(ThemeEvents.FilterUpdate, this.#handleFilterUpdate);
//   }

//   disconnectedCallback() {
//     super.disconnectedCallback();
//     if (this.infinityScrollObserver) {
//       this.infinityScrollObserver.disconnect();
//     }
//     // Remove the filter update listener
//     document.removeEventListener(ThemeEvents.FilterUpdate, this.#handleFilterUpdate);
//   }

//   #observeViewMore() {
//     const { viewMorePrevious, viewMoreNext } = this.refs;

//     // Return if neither element exists
//     if (!viewMorePrevious && !viewMoreNext) return;

//     // Create observer if it doesn't exist
//     if (!this.infinityScrollObserver) {
//       this.infinityScrollObserver = new IntersectionObserver(
//         async (entries) => {
//           // Wait for any in-progress view transitions to finish
//           if (viewTransition.current) await viewTransition.current;

//           for (const entry of entries) {
//             if (entry.isIntersecting) {
//               // Use current refs to check which element triggered
//               const { viewMorePrevious, viewMoreNext } = this.refs;

//               if (entry.target === viewMorePrevious) {
//                 this.#renderPreviousPage();
//               } else if (entry.target === viewMoreNext) {
//                 this.#renderNextPage();
//               }
//             }
//           }
//         },
//         {
//           rootMargin: '100px',
//         }
//       );
//     }

//     // Observe the view more elements
//     if (viewMorePrevious) {
//       this.infinityScrollObserver.observe(viewMorePrevious);
//     }

//     if (viewMoreNext) {
//       this.infinityScrollObserver.observe(viewMoreNext);
//     }
//   }

//   /**
//    * @param {{ page: number, url?: URL } | undefined} pageInfo - The page info
//    * @returns {boolean} Whether to use the page
//    */
//   #shouldUsePage(pageInfo) {
//     if (!pageInfo) return false;

//     const { grid } = this.refs;
//     const lastPage = grid?.dataset.lastPage;

//     if (!lastPage || pageInfo.page < 1 || pageInfo.page > Number(lastPage)) return false;

//     return true;
//   }

//   /**
//    * @param {"previous" | "next"} type
//    */
//   async #fetchPage(type) {
//     const page = this.#getPage(type);

//     // Always resolve the promise, even if we can't fetch the page
//     const resolvePromise = () => {
//       if (type === 'next') {
//         this.#resolveNextPagePromise?.();
//         this.#resolveNextPagePromise = null;
//       } else {
//         this.#resolvePreviousPagePromise?.();
//         this.#resolvePreviousPagePromise = null;
//       }
//     };

//     if (!page || !this.#shouldUsePage(page)) {
//       // Resolve the promise even if we can't fetch
//       resolvePromise();
//       return;
//     }

//     await this.#fetchSpecificPage(page.page, page.url);
//     resolvePromise();
//   }

//   /**
//    * @param {number} pageNumber - The page number to fetch
//    * @param {URL} [url] - Optional URL, will be constructed if not provided
//    */
//   async #fetchSpecificPage(pageNumber, url = undefined) {
//     const pageInfo = { page: pageNumber, url };

//     if (!url) {
//       const newUrl = new URL(window.location.href);
//       newUrl.searchParams.set('page', pageNumber.toString());
//       newUrl.hash = '';
//       pageInfo.url = newUrl;
//     }

//     if (!this.#shouldUsePage(pageInfo)) return;
//     const pageContent = await sectionRenderer.getSectionHTML(this.sectionId, true, pageInfo.url);
//     this.pages.set(pageNumber, pageContent);
//   }

//   async #renderNextPage() {
//     const { grid } = this.refs;

//     if (!grid) return;

//     const nextPage = this.#getPage('next');

//     if (!nextPage || !this.#shouldUsePage(nextPage)) return;
//     let nextPageItemElements = this.#getGridForPage(nextPage.page);

//     if (!nextPageItemElements) {
//       const promise = new Promise((res) => {
//         this.#resolveNextPagePromise = res;
//       });

//       // Trigger the fetch for this page
//       this.#fetchPage('next');

//       await promise;
//       nextPageItemElements = this.#getGridForPage(nextPage.page);
//       if (!nextPageItemElements) return;
//     }

//     grid.append(...nextPageItemElements);

//     this.#aspectRatioHelper.processNewElements();

//     history.pushState('', '', nextPage.url.toString());

//     requestIdleCallback(() => {
//       this.#fetchPage('next');
//     });
//   }

//   async #renderPreviousPage() {
//     const { grid } = this.refs;

//     if (!grid) return;

//     const previousPage = this.#getPage('previous');
//     if (!previousPage || !this.#shouldUsePage(previousPage)) return;

//     let previousPageItemElements = this.#getGridForPage(previousPage.page);
//     if (!previousPageItemElements) {
//       const promise = new Promise((res) => {
//         this.#resolvePreviousPagePromise = res;
//       });

//       // Trigger the fetch for this page
//       this.#fetchPage('previous');

//       await promise;
//       previousPageItemElements = this.#getGridForPage(previousPage.page);
//       if (!previousPageItemElements) return;
//     }

//     // Store the current scroll position and height of the first element
//     const scrollTop = window.scrollY;
//     const firstElement = grid.firstElementChild;
//     const oldHeight = firstElement ? firstElement.getBoundingClientRect().top + window.scrollY : 0;

//     // Prepend the new elements
//     grid.prepend(...previousPageItemElements);

//     this.#aspectRatioHelper.processNewElements();

//     history.pushState('', '', previousPage.url.toString());

//     // Calculate and adjust scroll position to maintain the same view
//     if (firstElement) {
//       const newHeight = firstElement.getBoundingClientRect().top + window.scrollY;
//       const heightDiff = newHeight - oldHeight;
//       window.scrollTo({
//         top: scrollTop + heightDiff,
//         behavior: 'instant',
//       });
//     }

//     requestIdleCallback(() => {
//       this.#fetchPage('previous');
//     });
//   }

//   /**
//    * @param {"previous" | "next"} type
//    * @returns {{ page: number, url: URL } | undefined}
//    */
//   #getPage(type) {
//     const { cards } = this.refs;
//     const isPrevious = type === 'previous';

//     if (!Array.isArray(cards)) return;

//     const targetCard = cards[isPrevious ? 0 : cards.length - 1];

//     if (!targetCard) return;

//     const currentCardPage = Number(targetCard.dataset.page);
//     const page = isPrevious ? currentCardPage - 1 : currentCardPage + 1;

//     const url = new URL(window.location.href);
//     url.searchParams.set('page', page.toString());
//     url.hash = '';

//     return {
//       page,
//       url,
//     };
//   }

//   /**
//    * @param {number} page
//    * @returns {NodeListOf<Element> | undefined}
//    */
//   #getGridForPage(page) {
//     const pageHTML = this.pages.get(page);

//     if (!pageHTML) return;

//     const parsedPage = new DOMParser().parseFromString(pageHTML, 'text/html');
//     const gridElement = parsedPage.querySelector('[ref="grid"]');
//     if (!gridElement) return;
//     return gridElement.querySelectorAll(':scope > [ref="cards[]"]');
//   }

//   get sectionId() {
//     const id = this.getAttribute('section-id');

//     if (!id) throw new Error('The section-id attribute is required');

//     return id;
//   }

//   /**
//    * Handle filter updates by clearing cached pages
//    */
//   #handleFilterUpdate = () => {
//     this.pages.clear();

//     // Resolve any pending promises to unblock waiting renders
//     this.#resolveNextPagePromise?.();
//     this.#resolvePreviousPagePromise?.();

//     this.#resolveNextPagePromise = null;
//     this.#resolvePreviousPagePromise = null;

//     // Store the current lastPage value to detect when it changes
//     const currentLastPage = this.refs.grid?.dataset.lastPage;

//     // We need to wait for the DOM to be updated with the new filtered content
//     // Using mutation observer to detect when the grid actually updates
//     const observer = new MutationObserver(() => {
//       // Check if data-last-page changed
//       const newLastPage = this.refs.grid?.dataset.lastPage;

//       if (newLastPage !== currentLastPage) {
//         observer.disconnect();

//         // Check if component is still connected
//         if (!this.isConnected) {
//           return;
//         }

//         // Now the DOM has been updated with the new filtered content
//         this.#observeViewMore();

//         // Fetch the next page
//         this.#fetchPage('next');
//       }
//     });

//     // Observe the grid for changes
//     const { grid } = this.refs;
//     if (grid) {
//       observer.observe(grid, {
//         attributes: true,
//         attributeFilter: ['data-last-page'],
//         childList: true, // Also watch for child changes in case the whole grid is replaced
//       });

//       // Set a timeout as a fallback in case the mutation never fires
//       setTimeout(() => {
//         if (observer) {
//           observer.disconnect();
//         }
//       }, 3000);
//     }
//   };
// }
import { Component } from '@theme/component';
import { sectionRenderer } from '@theme/section-renderer';
import { requestIdleCallback } from '@theme/utilities';
import { ThemeEvents } from '@theme/events';
import { PaginatedListAspectRatioHelper } from '@theme/paginated-list-aspect-ratio';

export default class PaginatedList extends Component {
  pages = new Map();
  #resolveNextPagePromise = null;
  #aspectRatioHelper;
  #saveScrollPosition = () => {
    sessionStorage.setItem('paginatedList:scrollY', window.scrollY.toString());
    sessionStorage.setItem('paginatedList:href', window.location.href);
  };

  connectedCallback() {
    super.connectedCallback();

    const templateCard = this.querySelector('[ref="cardGallery"]');
    if (templateCard) {
      this.#aspectRatioHelper = new PaginatedListAspectRatioHelper({
        templateCard,
      });
    }

    this.#fetchPage('next');
    this.#initializeState();

    // Load more button click
    const { viewMoreNext } = this.refs;
    if (viewMoreNext) {
      viewMoreNext.addEventListener('click', () => {
        this.#renderNextPage();
      });
    }

    // Initial count update
    this.#updateProductCount();

    window.addEventListener('pagehide', this.#saveScrollPosition);
    document.addEventListener(ThemeEvents.FilterUpdate, this.#handleFilterUpdate);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    window.removeEventListener('pagehide', this.#saveScrollPosition);
    document.removeEventListener(ThemeEvents.FilterUpdate, this.#handleFilterUpdate);
  }

  async #initializeState() {
    const urlPage = new URL(window.location.href).searchParams.get('page');
    const currentPage = urlPage ? Number(urlPage) : 1;

    const savedY = sessionStorage.getItem('paginatedList:scrollY');
    const savedHref = sessionStorage.getItem('paginatedList:href');
    const hasSavedScroll = savedY !== null && savedHref === window.location.href;

    if (currentPage > 1) {
      const pageNumbers = Array.from({ length: currentPage - 1 }, (_, i) => i + 1);

      await Promise.all(pageNumbers.map((p) => this.#fetchSpecificPage(p)));

      if (!this.isConnected) return;

      const { grid, viewMorePrevious } = this.refs;
      if (grid) {
        const fragments = [];
        for (const p of pageNumbers) {
          const elements = this.#getGridForPage(p);
          if (elements) fragments.push(...elements);
        }
        if (fragments.length > 0) {
          grid.prepend(...fragments);
          this.#aspectRatioHelper?.processNewElements();
          this.#updateProductCount();
        }
      }

      viewMorePrevious?.remove();
    }

    // prepend() and scrollTo() land in the same synchronous block after the
    // await, so the browser commits both as a single paint — no visible jump.
    if (hasSavedScroll) {
      window.scrollTo({ top: Number(savedY), behavior: 'instant' });
      sessionStorage.removeItem('paginatedList:scrollY');
      sessionStorage.removeItem('paginatedList:href');
    }
  }

  #shouldUsePage(pageInfo) {
    if (!pageInfo) return false;

    const { grid } = this.refs;
    const lastPage = grid?.dataset.lastPage;

    if (!lastPage || pageInfo.page < 1 || pageInfo.page > Number(lastPage)) {
      return false;
    }

    return true;
  }

  async #fetchPage(type) {
    const page = this.#getPage(type);

    if (!page || !this.#shouldUsePage(page)) {
      this.#resolveNextPagePromise?.();
      this.#resolveNextPagePromise = null;
      return;
    }

    await this.#fetchSpecificPage(page.page, page.url);
    this.#resolveNextPagePromise?.();
    this.#resolveNextPagePromise = null;
  }

  async #fetchSpecificPage(pageNumber, url = undefined) {
    const pageInfo = { page: pageNumber, url };

    if (!url) {
      const newUrl = new URL(window.location.href);
      newUrl.searchParams.set('page', pageNumber.toString());
      newUrl.hash = '';
      pageInfo.url = newUrl;
    }

    if (!this.#shouldUsePage(pageInfo)) return;

    const pageContent = await sectionRenderer.getSectionHTML(
      this.sectionId,
      true,
      pageInfo.url
    );

    this.pages.set(pageNumber, pageContent);
  }

  async #renderNextPage() {
    const { grid, viewMoreNext } = this.refs;
    if (!grid) return;

    const nextPage = this.#getPage('next');
    if (!nextPage || !this.#shouldUsePage(nextPage)) return;

    let nextPageItemElements = this.#getGridForPage(nextPage.page);

    if (!nextPageItemElements) {
      const promise = new Promise((res) => {
        this.#resolveNextPagePromise = res;
      });

      await this.#fetchPage('next');
      await promise;

      nextPageItemElements = this.#getGridForPage(nextPage.page);
      if (!nextPageItemElements) return;
    }

    if (viewMoreNext) {
      viewMoreNext.disabled = true;
      viewMoreNext.classList.add('is-loading');
    }

    grid.append(...nextPageItemElements);

    this.#updateProductCount();

    this.#aspectRatioHelper?.processNewElements();

    history.pushState('', '', nextPage.url.toString());

    const lastPage = Number(grid.dataset.lastPage);

    if (nextPage.page >= lastPage) {
      viewMoreNext?.remove();
    } else {
      requestIdleCallback(() => {
        this.#fetchPage('next');
      });

      if (viewMoreNext) {
        viewMoreNext.disabled = false;
        viewMoreNext.classList.remove('is-loading');
      }
    }
  }

  #getPage(type) {
    const { cards } = this.refs;
    if (!Array.isArray(cards)) return;

    const targetCard = cards[cards.length - 1];
    if (!targetCard) return;

    const currentCardPage = Number(targetCard.dataset.page);
    const page = currentCardPage + 1;

    const url = new URL(window.location.href);
    url.searchParams.set('page', page.toString());
    url.hash = '';

    return { page, url };
  }

  #getGridForPage(page) {
    const pageHTML = this.pages.get(page);
    if (!pageHTML) return;

    const parsedPage = new DOMParser().parseFromString(pageHTML, 'text/html');
    const gridElement = parsedPage.querySelector('[ref="grid"]');
    if (!gridElement) return;

    return gridElement.querySelectorAll(':scope > [ref="cards[]"]');
  }


  #updateProductCount() {
    const { grid, viewMoreNext } = this.refs;
    if (!grid || !viewMoreNext) return;

    const total = Number(grid.dataset.totalCount);
    const current = grid.querySelectorAll('[ref="cards[]"]').length;

    const countEl = viewMoreNext.querySelector('[data-current-count]');
    if (countEl) {
      countEl.textContent = current;
    }

    if (current >= total) {
      viewMoreNext.remove();
    }
  }

  #handleFilterUpdate = () => {
    this.pages.clear();
    this.#resolveNextPagePromise?.();
    this.#resolveNextPagePromise = null;

    const { viewMoreNext } = this.refs;

    setTimeout(() => {
      if (!this.isConnected) return;

      this.#fetchPage('next');
      this.#updateProductCount();

      if (viewMoreNext) {
        viewMoreNext.disabled = false;
        viewMoreNext.classList.remove('is-loading');
      }
    }, 300);
  };

  get sectionId() {
    const id = this.getAttribute('section-id');
    if (!id) throw new Error('The section-id attribute is required');
    return id;
  }
}